import { useLang } from "../i18n/LanguageContext";
import { PHONE_TEL, waLink } from "../constants/images";
import { Phone, MessageCircle } from "lucide-react";

const FloatingContact = () => {
  const { t } = useLang();

  return (
    <div className="fixed bottom-5 end-5 z-40 flex flex-col gap-3" data-testid="floating-contact">
      <a
        data-testid="floating-whatsapp-btn"
        href={waLink(t.contact.waMessage)}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t.contact.floatingWhatsapp}
        className="w-12 h-12 rounded-full bg-[#25D366] text-[#0D0F12] flex items-center justify-center shadow-xl hover:scale-110 transition-transform duration-300 tg-pulse"
      >
        <MessageCircle className="w-6 h-6" />
      </a>
      <a
        data-testid="floating-call-btn"
        href={PHONE_TEL}
        aria-label={t.contact.floatingCall}
        className="w-12 h-12 rounded-full bg-[#D96B27] text-[#0D0F12] flex items-center justify-center shadow-xl hover:scale-110 transition-transform duration-300"
      >
        <Phone className="w-6 h-6" />
      </a>
    </div>
  );
};

export default FloatingContact;
